var internet = {};
module['exports'] = internet;
internet.free_email = require("./free_email");
internet.domain_suffix = require("./domain_suffix");



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/it/internet/index.js
// module id = 1288
// module chunks = 0